(function($, undefined) {
	
	'use strict';
	var storyForm;
	var formValidator;
	
	var customStoryFormValidate = function() {
		var isValid = true;
		var imgElement = $('.story-form-image-input-preview .img-container', storyForm);	
		if (imgElement.css('background-image') === "none") {
			isValid = false;
			imgElement.addClass('error');
		} else {
			imgElement.removeClass('error');
		}
		return isValid;
	};
	
	var submitStoryForm = function() {
		var form = $(this).closest('form');
		form.addClass('processing');
		formValidator.validateForm(form);
		var isValid = customStoryFormValidate();
		
		if (!form.hasClass('has-error') && isValid) {
			var date = new Date();
			var y = date.getFullYear();
			var m = date.getMonth()+1 > 9 ? date.getMonth()+1 : '0'+(date.getMonth()+1);
			var d = date.getDate() > 9 ? date.getDate() : '0'+date.getDate();
			var id = $('[name=id]', form).length > 0 ? $('[name=id]', form).val() : null;
			var title = $('[name=field2]', form).val();
			var imgPath = $('.story-form-image-input-preview .img-container', form).attr('data-preview-item-id');
			var storyTextarea = $('[name=field4]', form);
			var text = tinymce.get(storyTextarea.attr('id')).getContent();
			var status = $('[name=field5]', form).prop('checked');
			date = y + "-" + m + "-" + d;
			var friendlyUrl = ''+title;
			
			var action = "/action/manageGenData";
			var params = {
				ajax: true,
				field1: 'story',
				field2: title,
				field3: imgPath,
				field4: text,
				field5: status,
				field6: date,
				friendlyUrl: friendlyUrl
			};
			if (id) {
				params.id = id;
			}
			$.ajax({
				url: action,
				method: "post",
				data: params,
				complete: function(response) {
					console.log(response.responseText);
					console.log(params);
					if (response.responseText.indexOf('success') !== -1) {
						location.reload();
					} else {
						form.removeClass('processing');
					}
				}
			});
		} 
		else {
			form.removeClass('processing');
		}
	};

	var removeImageLabel = function() {
		var t = $(this);
		var label = t.attr('data-label');
		var target = t.attr('data-target');
		var elementToUpdate = t.prev(target);
		
		if (elementToUpdate.css('background-image') !== 'none') {
			elementToUpdate.css('background-image', 'none');
			elementToUpdate.removeAttr('data-preview-item-id');
			updateLabel(label, '', 'fr');
		}
	};
	
	var init = function () {
		formValidator = Fw.component.models().form;
		storyForm = $('.story-admin-form');
		
		$('.save-story-btn', storyForm).on('click', submitStoryForm);
		$('.remove-preview-btn').on('click', removeImageLabel);
	};
	
	$(window).ready(function () {
		init();
	});
	
})(jQuery);
